// components/R0006TablesSection.js - Enhanced version building on your existing structure
import React from 'react';
import { Box, Typography } from '@mui/material';
import R0006SalesPerformanceTable from './R0006SalesPerformanceTable';
import R0006LaborHoursTable from './R0006LaborHoursTable';

/**
 * Enhanced Tables Section for R0006 Report
 * Now supports both area-level and store-level views with context indicators
 */
export default function R0006TablesSection({
  reportData,
  dataReady,
  selectedArea,
  dateRange,
  // New props for area/store support
  currentView,
  isAreasView,
  selectedAreaData,
  onTableRowClick,
  // Error handling props
  dataError,
  loadingMessage
}) {
  if (!dataReady) {
    // Show error message if there's an error
    if (dataError) {
      return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="h6" color="error" sx={{ mb: 2 }}>
            Failed to Load Data
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            {loadingMessage || dataError.message || 'Unknown error occurred'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please check your connection and try again, or contact support if the problem persists.
          </Typography>
        </Box>
      );
    }
    
    // Show normal "select date range" message if no error
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          {isAreasView 
            ? "Select a date range to view efficiency and productivity data by area"
            : `Select a date range to view efficiency and productivity data for ${selectedAreaData?.areaName || 'selected area'} stores`
          }
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ pb: 2 }}>
      


      {/* Sales Performance Table */}
      <R0006SalesPerformanceTable 
        data={reportData} 
        dataReady={dataReady}
        // Pass additional props for enhanced functionality
        isAreasView={isAreasView}
        currentView={currentView}
        onRowClick={onTableRowClick}
        selectedAreaData={selectedAreaData}
      />
      
      {/* Labor Hours Management Table */}
      <R0006LaborHoursTable 
        data={reportData} 
        dataReady={dataReady}
        // Pass additional props for enhanced functionality
        isAreasView={isAreasView}
        currentView={currentView}
        selectedAreaData={selectedAreaData}
        selectedArea={selectedArea}
      />

    </Box>
  );
}